import { ApiType, tzDateTimeStringToUtc } from "@gymflow/common";
import { InvoiceType } from "@gymflow/types";
import { useMutation } from "@tanstack/react-query";

export function useRevenueBySaleTypeReportCsv({
  api,
  tz,
}: {
  api: ApiType;
  tz: string;
}) {
  const csvMutation = useMutation({
    mutationFn: async ({
      invoiceType,
      dateFrom,
      dateTo,
    }: {
      invoiceType?: InvoiceType;
      dateFrom: string;
      dateTo: string;
    }) => {
      const result = await api.revenueApi.csv({
        invoiceType,
        dateFrom: tzDateTimeStringToUtc(dateFrom, tz),
        dateTo: tzDateTimeStringToUtc(dateTo, tz),
      });
      return result.data as string;
    },
  });
  return csvMutation;
}
